var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisible(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 7.33647C8.97667 7.33647 7.33641 8.97673 7.33641 11.0001C7.33641 13.0234 8.97667 14.6637 11 14.6637C13.0234 14.6637 14.6636 13.0234 14.6636 11.0001C14.6636 8.97673 13.0234 7.33647 11 7.33647ZM6.41364 11.0001C6.41364 8.46709 8.46703 6.4137 11 6.4137C13.533 6.4137 15.5864 8.46709 15.5864 11.0001C15.5864 13.5331 13.533 15.5865 11 15.5865C8.46703 15.5865 6.41364 13.5331 6.41364 11.0001Z",
    fill: "#B41730"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.395113 10.7626C2.80044 6.75761 6.63543 4.12207 11 4.12207C15.3646 4.12207 19.1996 6.75761 21.6049 10.7626L21.7476 11.0001L21.6049 11.2377C19.1996 15.2426 15.3646 17.8782 11 17.8782C6.63543 17.8782 2.80044 15.2426 0.395113 11.2377L0.252441 11.0001L0.395113 10.7626ZM1.33167 11.0001C3.61739 14.6603 7.11773 16.9554 11 16.9554C14.8823 16.9554 18.3827 14.6603 20.6684 11.0001C18.3827 7.33994 14.8823 5.04485 11 5.04485C7.11773 5.04485 3.61739 7.33994 1.33167 11.0001Z",
    fill: "#B41730"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisible);
export default __webpack_public_path__ + "static/media/visible.c0b8093f.svg";
export { ForwardRef as ReactComponent };